<template>
  <div class="card-content">
    <form @submit.prevent="buscar">
      <!-- Filtros principais -->
      <div class="columns is-multiline is-variable is-2">
        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Placa">
            <b-input
              v-model="filtro.placa"
              placeholder="Digite a Placa"
              @input="atualizarBusca"
            />
          </b-field>
        </div>

        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Empresa">
            <b-input
              v-model="filtro.nomeEmpresa"
              placeholder="Nome da Empresa"
              @input="atualizarBusca"
            />
          </b-field>
        </div>

        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Status">
            <b-select
              v-model="filtro.status"
              placeholder="Status"
              expanded
              @input="atualizarBusca"
            >
              <option :value="null">Todos</option>
              <option value="ATIVO">Ativo</option>
              <option value="APROVADO">Aprovado</option>
              <option value="INATIVO">Inativo</option>
              <option value="PENDENTE">Pendente</option>
              <option value="RECUSADO">Recusado</option>
            </b-select>
          </b-field>
        </div>

        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Tipo">
            <b-select
              v-model="filtro.tipo"
              placeholder="Tipo"
              expanded
              @input="atualizarBusca"
            >
              <option :value="null">Todos</option>
              <option value="AVULSO">Avulso</option>
              <option value="PADRAO">Padrão</option>
            </b-select>
          </b-field>
        </div>
      </div>

      <!-- Filtros avançados (colapsáveis) -->
      <b-collapse :open.sync="filtrosAvancadosVisiveis" class="mb-4">
        <div class="columns is-multiline is-variable is-2">
          <div class="column is-full-mobile is-one-third-desktop">
            <b-field label="Classificação">
              <b-select
                v-model="filtro.classificacao"
                placeholder="Classificação"
                expanded
                @input="atualizarBusca"
              >
                <option :value="null">Todas</option>
                <option value="AUTOMOVEL">Automóvel</option>
                <option value="MOTOCICLETA">Motocicleta</option>
                <option value="CAMINHAO">Caminhão</option>
                <option value="MAQUINA_MOVEL">Máquina Móvel</option>
              </b-select>
            </b-field>
          </div>

          <div class="column is-full-mobile is-one-third-desktop">
            <b-field label="Área">
              <b-select
                v-model="filtro.area"
                placeholder="Área"
                expanded
                @input="tratarFiltroDeArea"
              >
                <option :value="null">Todas</option>
                <option value="PRIMARIA">Primária</option>
                <option value="SECUNDARIA">Secundária</option>
                <option value="ALL">Ambas</option>
              </b-select>
            </b-field>
          </div>
        </div>
      </b-collapse>

      <!-- Ações -->
      <div class="is-flex is-align-items-center is-justify-content-space-between">
        <b-button @click="filtrosAvancadosVisiveis = !filtrosAvancadosVisiveis" type="is-text" size="is-small">
          {{ filtrosAvancadosVisiveis ? 'Ocultar filtros avançados' : 'Mostrar filtros avançados' }}
        </b-button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "FilterAcessoVeiculo",
  props: {
    initialFiltro: {
      type: Object,
      default: () => ({
        placa: null,
        tipo: null,
        status: null,
        nomeEmpresa: null,
        area: null,
        classificacao: null,
        areaPrimaria: null,
        areaSecundaria: null,
      }),
    },
  },
  data() {
    return {
      filtro: { ...this.initialFiltro },
      filtrosAvancadosVisiveis: false,
      timer: null,
    };
  },
  methods: {
    atualizarBusca() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.buscar(), 500);
    },
    buscar() {
      this.$emit("filtrar", this.filtro);
    },
    tratarFiltroDeArea() {
      const area = this.filtro.area;
      if (area === "PRIMARIA") {
        this.filtro.areaPrimaria = true;
        this.filtro.areaSecundaria = true;
      } else if (area === "SECUNDARIA") {
        this.filtro.areaPrimaria = false;
        this.filtro.areaSecundaria = true;
      } else if (area === "ALL") {
        this.filtro.areaPrimaria = true;
        this.filtro.areaSecundaria = true;
      } else {
        this.filtro.areaPrimaria = null;
        this.filtro.areaSecundaria = null;
      }
      this.filtro = {
        ...this.filtro,
        area: null,
        areaPrimaria: this.filtro.areaPrimaria.toString(),
        areaSecundaria: this.filtro.areaSecundaria.toString(),
      };
      this.$emit("filtrar", this.filtro);
    },
  },
};
</script>
